import { useEffect, useState } from "react"
import axios from "axios"
import ReactQuill from "react-quill-new"
import "react-quill-new/dist/quill.snow.css"
import { BASE_URL } from "../../../utils/requests"
import { getCookie } from "../../../utils/cookies"
import classes from "./StudentNote.module.scss"

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["clean"],
  ],
}

interface Student {
  id: number
  note?: string
}

const StudentNote = () => {
  const [params] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search)
    return {
      studentId: urlParams.get("studentId"),
      token: urlParams.get("token") || getCookie("token"),
    }
  })

  const [note, setNote] = useState("")
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState("")

  useEffect(() => {
    const fetchStudent = async () => {
      if (!params.studentId || !params.token) {
        setError("חסר מזהה תלמיד או טוקן")
        setLoading(false)
        return
      }

      try {
        const res = await axios.get(`${BASE_URL}/teacher/students`, {
          headers: {
            Authorization: `Bearer ${params.token}`,
            "X-App-Type": "teacher",
            "Cache-Control": "no-cache",
          },
        })

        const students: Student[] = res.data?.students ?? res.data ?? []
        const student = students.find((s) => s.id === Number(params.studentId))

        if (!student) {
          setError("התלמיד לא נמצא")
          setLoading(false)
          return
        }

        setNote(student.note || "")
      } catch {
        setError("שגיאה בטעינת נתוני התלמיד")
      }

      setLoading(false)
    }

    fetchStudent()
  }, [params])

  const onSave = async () => {
    setSaving(true)

    try {
      await axios.patch(
        `${BASE_URL}/teacher/students/edit`,
        { id: Number(params.studentId), note },
        {
          headers: {
            Authorization: `Bearer ${params.token}`,
            "X-App-Type": "teacher",
            "Cache-Control": "no-cache",
          },
        },
      )

      const url = new URL(window.location.href)
      url.searchParams.set("saved", "true")
      window.location.href = url.toString()
    } catch {
      setError("שגיאה בשמירת ההערה")
      setSaving(false)
    }
  }

  if (loading) {
    return <div className={classes.loading}>טוען...</div>
  }

  if (error) {
    return <div className={classes.error}>{error}</div>
  }

  return (
    <div className={classes.root}>
      <div className={classes.editor}>
        <ReactQuill theme="snow" value={note} onChange={setNote} modules={modules} />
      </div>
      <button className={classes.saveButton} onClick={onSave} disabled={saving}>
        {saving ? "שומר..." : "שמירה"}
      </button>
    </div>
  )
}

export default StudentNote
